const starInputs = document.querySelectorAll('.js-star-input');
const starInputsArray = Array.from(starInputs);

document.addEventListener('click', (e) => {
    const target = e.target.closest('.js-star-input');

    if (target) {
        const starIndex = starInputsArray.findIndex((item) => item === target);
        const starRatingInput = target.closest('.js-star-rating').querySelector('.js-star-rating-input');

        for (let i = 0; i < starInputsArray.length; i++) {
            starInputsArray[i].checked = i <= starIndex;
        }

        starRatingInput.value = target.value;
    }
});
